<template>
  <b-modal id="modal_contact_form" hide-header hide-footer size="lg">
    <template v-if="justsent">
      <h2>{{ sent_message_status }}</h2>
    </template>

    <div style="position:relative">
      <b-form v-bind:style="{ visibility: form_visibility }">
        <b-form-row class="mt-5 mb-3">
          <b-col md="1"> </b-col>
          <b-col md="5">
            <b-form-input
              v-model="firstname"
              type="text"
              class="form-control"
              :placeholder="$t('firstname')"
            ></b-form-input>
          </b-col>
          <b-col md="5">
            <b-form-input
              v-model="lastname"
              type="text"
              class="form-control"
              :placeholder="$t('lastname')"
            ></b-form-input>
          </b-col>
        </b-form-row>
        <b-form-row class="my-3">
          <b-col md="1"> </b-col>
          <b-col md="5">
            <b-form-input
              v-model="email"
              type="text"
              class="form-control"
              :placeholder="$t('email')"
            ></b-form-input>
          </b-col>
          <b-col md="5">
            <b-form-input
              v-model="phone"
              type="text"
              class="form-control"
              :placeholder="$t('phone')"
            ></b-form-input>
          </b-col>
        </b-form-row>
        <b-form-row class="my-3">
          <b-col md="1"> </b-col>
          <b-col md="10">
            <b-form-textarea
              v-model="message"
              type="text"
              class="form-control"
              :rows="10"
              :placeholder="$t('help')"
            ></b-form-textarea>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-5 mt-3">
          <b-col md="7"> </b-col>
          <b-col md="4">
            <vue-recaptcha
              ref="recaptcha"
              sitekey="6LciqUIUAAAAAA_lFOqtsQdaH57OiyzAt9BA6DWb"
            >
              <b-button
                @click="submit"
                type="submit"
                :block="true"
                variant="primary"
                class="h3 font-weight-bold font-alt"
                pill
                >{{ $t('submit') }}</b-button
              >
            </vue-recaptcha>
          </b-col>
        </b-form-row>
      </b-form>

      <div
        class="container flex-row h-100 spinner justify-content-center align-items-center"
        v-bind:class="spinner_class"
      >
        <scale-loader
          :loading="loading"
          :color="color"
          :height="height"
          :width="width"
        ></scale-loader>
      </div>
    </div>
  </b-modal>
</template>

<style>
.spinner {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.not-displayed {
  display: none;
}

.modal-open {
  overflow-y: scroll !important;
  padding-right: 0 !important;
}
</style>

<script>
import VueRecaptcha from 'vue-recaptcha'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

export default {
  name: 'ContactForm',
  components: {
    VueRecaptcha,
    ScaleLoader,
  },

  data() {
    return {
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      help: '',
      message: '',
      loading: true,
      sending: false,
      justsent: false,
      sent_message_status: '',
      color: '#2196f3',
      width: '64px',
      height: '64px',
    }
  },

  computed: {
    form_visibility() {
      let res
      if (this.sending) {
        res = 'hidden'
      } else {
        res = 'visible'
      }
      return res
    },
    spinner_class() {
      let res
      if (!this.sending) {
        res = 'not-displayed'
      } else {
        res = 'd-flex'
      }
      return res
    },
  },

  methods: {
    submit() {
      this.sending = true
      this.justsent = false
      let data = {
        firstname: this.firstname,
        lastname: this.lastname,
        email: this.email,
        phone: this.phone,
        message: this.message,
      }
      this.$http.post('/api/contact', data).then(
        () => {
          this.sending = false
          this.justsent = true
          this.sent_message_status = this.$i18n.t('sent_message_ok')
          this.$refs.recaptcha.reset()
        },
        () => {
          this.sending = false
          this.justsent = true
          this.sent_message_status = this.$i18n.t('sent_message_error')
          this.$refs.recaptcha.reset()
        }
      )
    },
  },
}
</script>
